import { createContext, useMemo, useState, useCallback, useContext } from "react";
import jwtDecode from "jwt-decode";

export const AuthContext = createContext({
    UserId: null,
    token: null,
    username:null,
    login: () => { },
    logout: () => { },
    ContractId: null,
    rememberMe: null,
    deviceType: null
});

export function AuthContextProvider({ children }) {

    const decodeLocalStorage = (localStorageItem) => {
        const decodedItem = jwtDecode(localStorage.getItem(localStorageItem))
        return {
            role: decodedItem.role,
            UserId: decodedItem.UserId,
            ContractId: decodedItem.ContractId,
            username:decodedItem.unique_name,
            deviceType:decodedItem.DeviceType
        }
    }

    const initialStateLoginProperties = {
        role: localStorage.getItem('accessToken') ? decodeLocalStorage('accessToken').role : null,
        UserId: localStorage.getItem('accessToken') ? decodeLocalStorage('accessToken').UserId : null,
        token: localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null,
        username:localStorage.getItem('accessToken') ? decodeLocalStorage('accessToken').username : null,
        ContractId: localStorage.getItem('accessToken') ? decodeLocalStorage('accessToken').ContractId : null,
        rememberMe: localStorage.getItem('rememberMeChecked') ? localStorage.getItem('rememberMeChecked') : null,
        deviceType: localStorage.getItem('deviceType') ? localStorage.getItem('deviceType') : null
    }


    const [UserId, setUserId] = useState(initialStateLoginProperties.UserId);
    const [token, setToken] = useState(initialStateLoginProperties.token);
    const [username, setUsername] = useState(initialStateLoginProperties.username);
    const [ContractId, setContractId] = useState(initialStateLoginProperties.ContractId)
    const [rememberMe, setRememberMe] = useState(initialStateLoginProperties.rememberMe)
    const [deviceType, setDeviceType] = useState(initialStateLoginProperties.deviceType)

    const login = useCallback((accessToken, rememberValue) => {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("rememberMeChecked", rememberValue)
        const decodedToken = jwtDecode(accessToken);
        setUserId(decodedToken.UserId);
        setUsername(decodedToken.unique_name);
        setToken(accessToken);
        setContractId(decodedToken.ContractId)
        setRememberMe(rememberValue)
        setDeviceType(decodedToken.DeviceType)
        localStorage.setItem("deviceType", decodedToken.DeviceType);
    }, [])
    const logout = useCallback(() => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("rememberMeChecked")
        setUserId(null);
        setToken(null);
        setUsername(null);
        setContractId(null)
        setRememberMe(null)
        setDeviceType(null)
    }, [])
    const memoedValue = useMemo(
        () => ({
            UserId,
            token,
            username,
            login,
            logout,
            ContractId,
            rememberMe,
            deviceType
        }),
        [UserId,username, login, logout, token, ContractId, rememberMe,deviceType]
    );

    return (
        <AuthContext.Provider value={memoedValue}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuthContext() {
    return useContext(AuthContext)
}